import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BikeBenefitListItemExtension } from './bike-benefit-list-item.extension';
import { BikeBenefitMetadataExtension } from './bike-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('bike')
    .add(BenefitMetadataExtensionInterface, new BikeBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new BikeBenefitListItemExtension())
    .build(),
);
